<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="ht1" epub:type="halftitlepage">
<h1 class="halftitle" id="ht1"><span aria-label=" Page viii. " epub:type="pagebreak" id="page_viii" role="doc-pagebreak">THE WEB<br/>OF<br/>MEANING</span></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?cb28ac1a